import Choices from "choices.js";
import "choices.js/src/styles/choices";

document.addEventListener("DOMContentLoaded", initChoices);
document.addEventListener("wpcf7init", initChoices);

function initChoices() {

  document.querySelectorAll(".js-choice").forEach((el) => {

	if (el.dataset.choicesLoaded) return;

	new Choices(el, {

		searchEnabled: true,
		searchFields: ["label"],
		searchResultLimit: -1,
		itemSelectText: "",
		shouldSort: false,
		removeItemButton: true, // Removable tags


	});

	el.dataset.choicesLoaded = true;
	
  });

}